import React, { Component } from 'react'
/**
 * Converts JSON object to a nested object
 * @param {JSONobject} {"property.with.dots": "value", "foo": "bar"}
 * @return {Object} { property: { with: { dots: value } }, foo: "bar" }
 */

const convertJSONToNestedObject = object => {
    if (!object) {
        return {}
    }
    let result = {}
    Object.keys(object).forEach(function (k) {
        var path = k.split('.')
        var value = object[k]
        var last = path.pop()

        path.reduce(function (o, k) {
            return (o[k] = o[k] || {})
        }, result)[last] = value
    })
    return result
}

export default elementId => WrappedComponent => {
    const el = document.getElementById(elementId)
    const translations = el
        ? convertJSONToNestedObject(
            JSON.parse(decodeURI(el.getAttribute('data-translations')))
        )
        : []
    return class extends Component {
        render() {
            return <WrappedComponent {...this.props} translations={translations} />
        }
    }
}
